import React from 'react'

type FlexProps = {
  children?: React.ReactNode
  testId?: string
} & Pick<
  React.CSSProperties,
  | 'alignSelf'
  | 'flex'
  | 'flexWrap'
  | 'flexDirection'
  | 'justifyContent'
  | 'alignItems'
  | 'alignContent'
  | 'minWidth'
> &
  (
    | (Pick<React.CSSProperties, 'gap'> & { columnGap?: never; rowGap?: never })
    | (Pick<React.CSSProperties, 'columnGap' | 'rowGap'> & { gap?: never })
  )

export const Flex = ({
  testId,
  flex,
  alignSelf,
  justifyContent,
  flexDirection,
  alignItems,
  gap,
  columnGap,
  rowGap,
  alignContent,
  flexWrap,
  children,
  minWidth,
}: FlexProps) => (
  <div
    data-testid={testId}
    style={{
      alignSelf,
      display: 'flex',
      justifyContent,
      flexDirection,
      flexWrap,
      alignItems,
      alignContent,
      flex,
      minWidth,
      ...(!!gap && { gap }),
      ...((!!rowGap || !!columnGap) && { rowGap, columnGap }),
    }}
  >
    {children}
  </div>
)
